import qs from "qs";
import {apiVoissa, apiUrl} from "../../libs/api";

const MONGO_OBJECT_ID_REGEXP = /^[0-9a-fA-F]{24}$/;

const normalizeMediaId = (value) => {
    if (typeof value !== "string") return null;
    const normalized = value.trim();
    return MONGO_OBJECT_ID_REGEXP.test(normalized) ? normalized : null;
};

const normalizeMediaTagsQuery = (value) => {
    if (Array.isArray(value)) {
        const normalizedTags = value
            .map(normalizeMediaId)
            .filter(Boolean);
        return normalizedTags.length ? normalizedTags : undefined;
    }

    return normalizeMediaId(value) || undefined;
};

const normalizeMediasQuery = (query = {}) => {
    const normalizedQuery = {...query};
    const normalizedTags = normalizeMediaTagsQuery(normalizedQuery.tags);

    if (normalizedTags) {
        normalizedQuery.tags = normalizedTags;
    } else {
        delete normalizedQuery.tags;
    }

    return normalizedQuery;
};



export const fetchMedias = (query = {}, config = {}) => {
    let sort = ['-createdAt', '-count.totalReactions', '-count.totalReactions', '-count.totalReactions', '-count.comment'];
    query = normalizeMediasQuery({...query, sort: sort[query.sort] || sort[0]});
    return apiVoissa.get(`/medias?${qs.stringify(query)}`, config)
};

export const fetchMediasExplorer = (query = {}, config = {}) => {
    return apiVoissa.get(`/explorer?${qs.stringify(query)}`, config)
};

export const fetchCategorizedMedias = (query = {}, config = {}) => {
    query = qs.stringify(query).replaceAll("%5B0%5D", "").replaceAll("%5B1%5D", "");
    return apiVoissa.get(`/medias/categorized?${query}`, config);
};

export const fetchCategorizedMediasCount = (query = {}, config = {}) => {
    query = qs.stringify(query).replaceAll("%5B0%5D", "").replaceAll("%5B1%5D", "");
    return apiVoissa.get(`/medias/categorized-count?${query}`, config);
};

export const moveMedia = (mediaId = null, data = {}, config = {}) => apiVoissa.patch(`/medias/${mediaId}/move`, data, config);

export const fetchMedia = (mediaId = null, query = {}, config = {}) => {
    const normalizedMediaId = normalizeMediaId(mediaId);
    if (!normalizedMediaId) {
        return Promise.reject(new Error('Id invalid'));
    }
    return apiVoissa.get(`/medias/${normalizedMediaId}?${qs.stringify(query)}`, config);
};
export const updateMedia = (mediaId = null, data = {}, config = {}) => apiVoissa.patch(`/medias/${mediaId}`, data, config);
export const updateCoverVideoFile = (mediaId = null, data = {}, config = {}) => apiVoissa.patch(`/medias/${mediaId}/update-cover-video-file`, data, config);
export const updateCoverVideoFfmpeg = (mediaId = null, data = {}, config = {}) => apiVoissa.patch(`/medias/${mediaId}/update-cover-video-ffmpeg`, data, config);
export const updateMediaCategories = (mediaId, data = {}, config = {}) => apiVoissa.patch(`/medias/${mediaId}/update-categories`, data, config);
export const deleteMedia = (mediaId = null, config = {}) => apiVoissa.delete(`/medias/${mediaId}`, config);

export const setMediaCountViews = (id = null, config = {}) => apiVoissa.patch(`/medias/${id}/view`, config);

export const createMediaBookmark = (mediaId = null, config = {}) => apiVoissa.post(`/medias/${mediaId}/bookmarks`, config);
export const deleteMediaBookmark = (mediaId = null, config = {}) => apiVoissa.delete(`/medias/${mediaId}/bookmarks`, config);

export const createMediaRepost = (mediaId = null, config = {}) => apiVoissa.post(`/medias/${mediaId}/reposts`, config);
export const deleteMediaRepost = (mediaId = null, config = {}) => apiVoissa.delete(`/medias/${mediaId}/reposts`, config);

export const updateMediaContentRating = (mediaId = null, data = {}, config = {}) => apiVoissa.patch(`/medias/${mediaId}/update-content-rating`, data, config);

export const updateMediaContentFeature = (mediaId = null, data = {}, config = {}) => apiVoissa.patch(`/medias/${mediaId}/update-content-feature`, data, config);

export const contentRatingReviewRequest = (mediaId = null, data = {}, config = {}) => apiVoissa.patch(`/medias/${mediaId}/content-rating-review-request`, data, config);

// Statistiques d'un média (premium) — KPI + courbes par jour/genre + liste des membres
export const fetchMediaStats = (mediaId, query = {}, config = {}) => apiVoissa.get(`/medias/${mediaId}/stats?${qs.stringify(query)}`, config);
export const fetchMediaStatsMembers = (mediaId, query = {}, config = {}) => apiVoissa.get(`/medias/${mediaId}/stats/members?${qs.stringify(query)}`, config);
export const MEDIA_STATS_KEY = `media-stats`;
export const MEDIA_STATS_MEMBERS_KEY = `media-stats-members`;

export const MEDIAS_KEY = `medias`;
export const MEDIAS_EXPLORER_KEY = `medias-exporer`;
export const MEDIAS_CATEGORIZED_KEY = `medias-categorized`;
export const MEDIAS_CATEGORIZED_COUNT_KEY = `medias-categorized-count`;
export const MEDIAS_TAGS_KEY = `medias-tags`;

export const MEDIA_KEY = `media`;
export const MEDIA_SET_COUNT_KEY = `media-set-count`;

// TEMPORAIRE — diagnostic d'upload (28/09/2026), à retirer avec libs/uploadDiagnostic.js.
// Quand l'envoi d'un média échoue AVANT d'atteindre l'API (erreur réseau), le serveur n'a aucune
// trace : ce signalement est le seul moyen de savoir ce qui s'est passé. Il ne transporte pas le
// fichier, seulement sa description — donc il passe là où l'envoi a échoué.
export const reportUploadFailure = (report) =>
    apiUrl.post(`/medias/upload-diagnostic`, report, { timeout: 8000 });